import React from "react";
import "../../css/common/ErrorNotifier.css";

function ErrorNotifier(props) {
  return (
    <div className="error-notification-box">
      <span className="error-notification">
        <i className="material-icons">error</i>
        {props.message}
      </span>
    </div>
  );
}
export default ErrorNotifier;
